import { ApiError } from "@odingard/sdk-client";
import { api } from "../../lib/api";
import { useAsync } from "../../lib/useAsync";

export interface Member {
  id: string;
  email: string;
  displayName: string;
  role: string;
}

export interface People {
  members: Member[];
  /** Identifiers are how the records are stored; nobody should have to read one. */
  name: (id: string | null | undefined) => string;
}

export function usePeople(orgId: string): People {
  const state = useAsync<Member[]>(async () => (await api.members(orgId)).members, [orgId]);
  const members = state.data ?? [];
  return {
    members,
    name: (id) => {
      if (!id) return "Unassigned";
      const match = members.find((m) => m.id === id);
      return match ? match.displayName || match.email : id;
    },
  };
}

/**
 * A refusal is worth reading. A missing permission in particular should say
 * which one, because "forbidden" leaves the reader with nothing to ask for.
 */
export function message(err: unknown, fallback: string): string {
  if (!(err instanceof ApiError)) return fallback;
  if (err.code === "forbidden" && typeof err.details?.permission === "string") {
    return `You do not hold ${err.details.permission}, so this action is not yours to take.`;
  }
  return err.message;
}
